import React, { useContext, useEffect } from 'react';
import Helmet from 'react-helmet';

import Section from '@latitude/section';
import { Link } from '@latitude/link';
import { BUTTON_STYLE } from '@latitude/core/utils/constants';
import { Heading4 } from '@latitude/heading';

import Layout from '@/components/layout';
import AchPageHeaderSection from './_ach-page-header';
import GoMicrositeHeader from '../_go-microsite-header';
import { PageContext } from '@/context/PageContext';
import HeroBanner from '@/components/lab-components/HeroBanner';

const buttonHref = '/credit-cards/gomastercard/additional-cardholder/details/';

function AchLandingPage(props) {
  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  /** - END - */

  useEffect(() => {
        if (window?.location){
          window.location.replace('https://latitudefs.zendesk.com/hc/en-au/articles/36591875170577-Additional-Cardholders')
        }
      },[])
  
  return (
    <Layout location={props.location}>
      <main className="navigation-spacer">
        <Helmet>
          <link
            rel="canonical"
            href="https://www.latitudefinancial.com.au/credit-cards/gomastercard/additional-cardholder/"
          />
          <meta
            name="description"
            content="Add an additional cardholder to your Latitude GO Mastercard"
          />
          <title>Additional Card Holder Landing | GO Mastercard</title>
        </Helmet>
        {state?.heroBannerData?.[0] ? (
          <HeroBanner {...state?.heroBannerData[0]} />
        ) : (
          <AchPageHeaderSection />
        )}
        <GoMicrositeHeader data={state.secondaryNavData} />

        <Section>
          <Heading4>Share the benefits with an additional cardholder</Heading4>

          <div className="row">
            <div className="col-md-8">
              <p>
                Adding an Additional Cardholder on your account is free and can
                help provide extra security for emergencies or help with your
                life admin. As the account holder, you're still responsible for
                making repayments and any outstanding balances on your account.
              </p>
              <p>
                Your additional cardholder can make purchases, request cash
                advances, update their PIN and report their card as lost or
                stolen, but they won't be able to register or sign in to your
                account online via the website and mobile app, or receive any
                statements. You will also need to activate your card before they
                can activate theirs.
              </p>
              <p>
                It's a good idea to talk to your additional cardholder about how
                you'd like the card to be used. With some good habits in place,
                you can both enjoy the benefits of the Latitude 28° Global
                Platinum Mastercard® credit card. Speaking of good habits, set
                up a direct debit for repayments to avoid late fees if you
                haven't already.
              </p>
              <p>Before you complete the online form, please have handy:</p>
              <p>
                <ul>
                  <li>
                    <strong>Your account number</strong> &mdash; this can be
                    found on your statement and your application approval email
                  </li>
                  <li>
                    <strong>Additional Cardholder's full name</strong> &mdash;
                    as it appears on their ID
                  </li>
                  <li>
                    <strong>Additional Cardholder's date of birth</strong>{' '}
                    &mdash; make sure your nominated additional cardholder is an
                    Australian resident and over 16 years of age
                  </li>
                  <li>
                    <strong>Additional Cardholder's email address</strong>{' '}
                    &mdash; so we can contact them to complete the request
                  </li>
                </ul>
              </p>

              <p>
                Simply complete the <a href={buttonHref}>online form</a>.
              </p>
            </div>
            <div className="col-md-4">
              <Link
                button={BUTTON_STYLE.SECONDARY}
                css={{
                  margin: '0 auto',
                  width: 'fit-content'
                }}
                href={buttonHref}
              >
                Complete Today
              </Link>
            </div>
          </div>
        </Section>
      </main>
    </Layout>
  );
}

export default AchLandingPage;
